import type { CatalogPage, CatalogQuery, CatalogRecord } from '@okmaps/shared';
import { baseApi } from './baseApi.js';

/**
 * The dataset catalog, sourced from OGI's GeoNetwork CSW service.
 *
 * The proxy does the XML-to-JSON work once and joins each record against the
 * WMS/WFS capabilities so `renderable` is trustworthy. The 193 catalog records
 * and the 266 WFS / 724 WMS layers are different sets; a record that cannot be
 * drawn is labeled as such rather than hidden, so nothing in the UI silently
 * fails when a user clicks it.
 */
export const catalogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    searchCatalog: build.query<CatalogPage, CatalogQuery>({
      query: (q) => ({
        url: 'catalog',
        params: {
          ...(q.text ? { text: q.text } : {}),
          ...(q.category ? { category: q.category } : {}),
          ...(q.renderableOnly ? { renderable: '1' } : {}),
          ...(q.limit !== undefined ? { limit: String(q.limit) } : {}),
          ...(q.offset !== undefined ? { offset: String(q.offset) } : {}),
        },
      }),
      providesTags: ['Catalog'],
    }),

    getCatalogRecord: build.query<CatalogRecord, string>({
      query: (id) => `catalog/${encodeURIComponent(id)}`,
      providesTags: (_r, _e, id) => [{ type: 'Catalog' as const, id }],
    }),
  }),
});

export const { useSearchCatalogQuery, useGetCatalogRecordQuery } = catalogApi;
